module.exports = __webpack_public_path__ + "static/media/package.e7dda2be.svg";